$ = require 'jquery'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/power_ups_voting_prefs'

module.exports = class VotingSettingsView extends View
  viewTitleKey: 'voting settings'

  initialize: ->
    @listenTo @model,
      'change:prefs': @render

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-voting-select:not(.disabled)': 'selectPerm'
    'click .js-vote-count-select:not(.disabled)': 'hideVotes'

  render: ->
    @$el.html(template({
      canChange: @model.editable()
      canSetObservers: @model.getOrganization()?.isFeatureEnabled('observers')
      canSetOrganization: @model.hasOrganization()
      canSetPublic: @model.isPublic()
      votingMode: @model.getPref('voting')
      hideVotes: @model.getPref('hideVotes')
    }))

    @

  selectPerm: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-voting-select')

    setting = $target.attr('name')

    if @sendGASEvent
      Analytics.sendTrackEvent
        action: 'set'
        actionSubject: 'boardPref'
        actionSubjectId: 'votingBoardPref'
        source: 'votingSettingsInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''
        attributes:
          current: @model.getPref('voting')
          changeTo: setting

    @model.setPref('voting', setting)

  hideVotes: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-vote-count-select')
    @model.setPref('hideVotes', !@model.getPref('hideVotes'))
    if @sendGASEvent
      Analytics.sendTrackEvent
        action: 'set'
        actionSubject: 'boardPref'
        actionSubjectId: 'hideVotesBoardPref'
        source: 'votingSettingsInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''
        attributes:
          hideVotesEnabled: @model.getPref('hideVotes')
